import { useRef, useState } from 'react';
import { toast } from 'sonner';
import { Upload, Loader2 } from 'lucide-react';
import api from '../lib/api';

export default function ImageUpload({ value, onUploaded, label = 'Carica immagine', testId = 'image-upload' }) {
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('file', file);
      const { data } = await api.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      onUploaded(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      toast.success('Immagine caricata');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Errore nel caricamento');
    } finally {
      setLoading(false);
      e.target.value = '';
    }
  };

  return (
    <div className="flex items-center gap-3">
      {value && (
        <img src={value} alt="" className="w-16 h-16 object-cover rounded-xl border border-slate-200 shrink-0" />
      )}
      <button type="button" onClick={() => ref.current?.click()} disabled={loading} data-testid={testId}
        className="flex items-center gap-2 text-sm font-medium text-slate-600 border border-dashed border-slate-300 rounded-xl px-4 py-3 hover:border-brand transition-colors">
        {loading ? <Loader2 size={15} className="animate-spin" /> : <Upload size={15} strokeWidth={1.5} />}
        {loading ? 'Caricamento...' : label}
      </button>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={handleFile} />
    </div>
  );
}
